import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqData } from "../types";

export const getFaqDetails = async (
  faqGroupId: string,
  faqId: string,
): Promise<FaqData | null> => {
  const collectionRef = collection(db, `faqGroups/${faqGroupId}/faqs`);
  const faqSnap = await getDoc(doc(collectionRef, faqId));

  if (!faqSnap.exists()) {
    return null;
  }

  return { ...faqSnap.data(), id: faqSnap.id } as FaqData;
};
